module.exports = __webpack_public_path__ + "img/avatar-1.95caeffb.png";